import React from 'react';
import { Link } from 'react-router-dom';
import { Typography, Button, Paper, Container, Box, Fade, useTheme } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import HomeIcon from '@mui/icons-material/Home';
import AirplanemodeActiveIcon from '@mui/icons-material/AirplanemodeActive';

const NotFound = () => {
  const theme = useTheme();

  return (
    <Container maxWidth="md" sx={{ mt: { xs: 6, md: 12 } }}>
      <Fade in={true} timeout={800}>
        <Paper
          elevation={3}
          className="glass-morphism"
          sx={{
            p: { xs: 4, md: 6 },
            borderRadius: 3,
            textAlign: 'center',
          }}
        >
          <Box className="fade-in">
            <AirplanemodeActiveIcon
              sx={{
                fontSize: 40,
                mb: 2,
                transform: 'rotate(45deg)',
                color: 'primary.main',
                opacity: 0.7
              }}
            />
            <ErrorOutlineIcon
              sx={{
                fontSize: { xs: 60, md: 80 },
                color: 'error.main',
                mb: 2,
                filter: 'drop-shadow(0 4px 8px rgba(239, 68, 68, 0.2))'
              }}
            />

            <Typography
              variant="h3"
              component="h1"
              gutterBottom
              sx={{
                fontWeight: 700,
                fontSize: { xs: '2rem', md: '2.5rem' },
                background: 'linear-gradient(45deg, #ef4444 30%, #f87171 90%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
            >
              404 - Page Not Found
            </Typography>

            <Typography
              variant="body1"
              color="text.secondary"
              sx={{ mb: 3, maxWidth: '80%', mx: 'auto' }}
            >
              The page you're looking for doesn't exist or has been moved.
            </Typography>

            <Button
              component={Link}
              to="/"
              variant="contained"
              color="primary"
              startIcon={<HomeIcon />}
              className="modern-button"
              sx={{
                mt: 3,
                px: 4,
                py: 1.5,
                borderRadius: '12px',
                fontWeight: 600,
                fontSize: '1rem',
                background: theme.palette.mode === 'dark'
                  ? 'linear-gradient(45deg, #6366f1 30%, #818cf8 90%)'
                  : 'linear-gradient(45deg, #4f46e5 30%, #6366f1 90%)',
                boxShadow: theme.palette.mode === 'dark'
                  ? '0 4px 20px rgba(99, 102, 241, 0.5)'
                  : '0 4px 20px rgba(79, 70, 229, 0.3)',
                transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                '&:hover': {
                  transform: 'translateY(-3px) scale(1.02)',
                  boxShadow: theme.palette.mode === 'dark'
                    ? '0 8px 30px rgba(99, 102, 241, 0.6)'
                    : '0 8px 30px rgba(79, 70, 229, 0.4)',
                }
              }}
            >
              Back to Home
            </Button>
          </Box>
        </Paper>
      </Fade>
    </Container>
  );
};

export default NotFound;
